import React, { Component } from 'react';
import { Accordion, AccordionItem, AccordionItemHeading, AccordionItemButton, AccordionItemPanel } from 'react-accessible-accordion';
import Header from '../layout/Header';

export class Contact_01 extends Component {
    render() {
        
        return (
            <div className="site-main">
                <Header />
                {/* page-title */}
                <div className="ttm-page-title-row">
                    <div className="container-xl">
                        <div className="row">
                            <div className="col-md-12"> 
                                <div className="title-box">
                                    <div className="page-title-heading">
                                        <h1 className="title">Contact Us</h1>
                                    </div>{/* /.page-title-captions */}
                                    <div className="breadcrumb-wrapper">
                                    <span>
                                        <a title="Homepage" href={process.env.PUBLIC_URL + '/'} >&nbsp;&nbsp;Home</a>
                                    </span>
                                    <span className="ttm-bread-sep">&nbsp; : : &nbsp;</span>
                                    <span>Contact Us</span>
                                    </div>  
                                </div>
                            </div>{/* /.col-md-12 */}  
                        </div>{/* /.row */}  
                    </div>{/* /.container */}                      
                </div>
                {/* page-title end*/}
                <section class="ttm-row bg-layer-equal-height res-991-pb-0 res-991-pt-0 clearfix">
                    <div class="container">
                        <div class="row no-gutters">
                            <div class="col-lg-6">
                                <div class="ttm-col-bgcolor-yes ttm-bgcolor-darkgrey ttm-textcolor-white col-bg-img-five ttm-col-bgimage-yes ttm-bg">
                                    <div class="ttm-col-wrapper-bg-layer ttm-bg-layer ttm-bgcolor-darkgrey">
                                        <div class="ttm-col-wrapper-bg-layer-inner ttm-bgcolor-darkgrey"></div>
                                    </div>
                                    <div class="layer-content map-contect-form">
                                        <div class="section-title">
                                            <div class="title-header mb-0">
                                                <h2 class="title">Web designing in a powerful way of just not a profession, however</h2>
                                            </div>
                                        </div>
                                        <form action="#" class="query_form wrap-form clearfix mt-25 res-991-mt-0 position-relative" method="post">
                                            <div class="row">
                                                <div class="col-md-12">
                                                    <label>
                                                        <span class="text-input" /><input name="name" type="text" placeholder="Name" required="required" />
                                                    </label>
                                                </div>
                                                <div class="col-md-12">
                                                    <label>
                                                        <span class="text-input" /><input name="email" type="text" placeholder="Email" required="required" />
                                                    </label>
                                                </div>
                                                <div class="col-md-12">
                                                    <label>
                                                        <span class="text-input"><input name="message" type="text" placeholder=" phone" required="required"></input></span>
                                                    </label>
                                                </div>
                                                <div class="col-md-12">
                                                    <label>
                                                        <span class="text-input"><textarea name="message" rows="5" placeholder=" Your message" required="required"></textarea></span>
                                                    </label>
                                                </div>
                                                <div class="col-md-12">
                                                    <label>
                                                    <span class="checkbox"><input type="checkbox" name="cookies-consent" className="mr-10" id="cookies-consent2" />
                                                        Accept <a href="#"> Terms of services</a> and <a href="#"> Privacy Policy.</a></span>
                                                    </label>
                                                </div>
                                                <div class="col-md-12">
                                                    <div class="mt-25">
                                                    <button class="ttm-btn ttm-btn-size-md ttm-btn-shape-round ttm-btn-style-fill ttm-btn-color-gradiant" type="submit">Submit Now</button>
                                                </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-6">
                                <div class="ttm-bg ttm-bgcolor-grey spacing-6">
                                    <div class="section-title mb-15">
                                        <div class="title-header mb-0">
                                            <h2 class="title">Get in touch</h2>
                                        </div>
                                        <div class="title-desc mb-40">
                                            <p>Web designing in a powerful way of just not a profession, however for our Company. We have a tendency to believe the idea that smart looking to believe the idea that smart looking</p>
                                        </div>
                                    </div>
                                    <div class="contact-address-box">
                                        <div class="address-box-info">
                                            <h3 class="address-box-heading">Schweizer</h3>
                                            <div class="address-box-text">Schweizer Skischule lohnerhubels <br /> goergam Mtrasse 95 CH-3123 Belp</div>
                                        </div>
                                        <div class="address-box-map-link">
                                            <a href="https://www.google.com/maps" class="address-box-link">View On Map</a>
                                        </div>
                                    </div>
                                    <div class="contact-address-box last-child">
                                        <div class="address-box-info">
                                            <h3 class="address-box-heading">Maryam jakarta</h3>
                                            <div class="address-box-text">Schweizer Skischule lohnerhubels <br /> goergam Mtrasse 95 CH-3123 Belp</div>
                                        </div>
                                        <div class="address-box-map-link">
                                            <a href="https://www.google.com/maps" class="address-box-link">View On Map</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section class="ttm-row bg-base-grey map-accordion-section ttm-bgcolor-grey clearfix">
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-5 col-md-12">
                                <div class="contentmap">
                                    <div class="section-title">
                                        <div class="title-header">
                                            <h2 class="title">Frequently asked questions</h2>
                                        </div>
                                        <div class="title-desc">
                                            <p>Web designing in a powerful way of just not a profession, however for our Company. We have a tendency to believe the idea that smart looking to believe the idea that smart looking.</p>
                                        </div>
                                        <div class="mt-15">
                                            <h3 class="contact-heading-h3">Social media</h3>
                                            <ul class="social-icons map-links res-991-mb-20">
                                                <li><a href="https://www.facebook.com/preyantechnosys19" rel="noopener" aria-label="facebook">Facebook</a></li>
                                                <li><a href="https://twitter.com/PreyanTechnosys" rel="noopener" aria-label="twitter">Twitter</a></li>
                                                <li><a href="https://www.instagram.com/preyan_technosys/" rel="noopener" aria-label="twitter">Instagram</a></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-7 col-md-12">
                                <Accordion preExpanded={['foo']} className="accordion style3">
                                    <AccordionItem>
                                        <AccordionItemHeading>
                                            <AccordionItemButton>
                                                01. Curious about how to your own UX strategy?
                                            </AccordionItemButton>
                                        </AccordionItemHeading>
                                        <AccordionItemPanel>
                                            <p>
                                                Web designing in a powerful way of just not a profession, however for our Company. We have a tendency
                                                to believe the idea that smart looking to believe the idea that smart looking.
                                            </p>
                                        </AccordionItemPanel>
                                    </AccordionItem>
                                    <AccordionItem>
                                        <AccordionItemHeading>
                                            <AccordionItemButton>
                                                02. Where Could a Career in UX Take You? 
                                            </AccordionItemButton>
                                        </AccordionItemHeading>
                                        <AccordionItemPanel>
                                            <p>
                                                Web designing in a powerful way of just not a profession, however for our Company. We have a tendency
                                                to believe the idea that smart looking to believe the idea that smart looking.
                                            </p>
                                        </AccordionItemPanel>
                                    </AccordionItem>
                                    <AccordionItem>
                                        <AccordionItemHeading>
                                            <AccordionItemButton>
                                                03. What Is a Problem Statement in UX?
                                            </AccordionItemButton>
                                        </AccordionItemHeading>
                                        <AccordionItemPanel>
                                            <p>
                                                Web designing in a powerful way of just not a profession, however for our Company. We have a tendency
                                                to believe the idea that smart looking to believe the idea that smart looking.
                                            </p>
                                        </AccordionItemPanel>
                                    </AccordionItem>
                                    <AccordionItem>
                                        <AccordionItemHeading>
                                            <AccordionItemButton>
                                                04.  What are the users are facing?
                                            </AccordionItemButton>
                                        </AccordionItemHeading>
                                        <AccordionItemPanel>
                                            <p>
                                                Web designing in a powerful way of just not a profession, however for our Company. We have a tendency
                                                to believe the idea that smart looking to believe the idea that smart looking.
                                            </p>
                                        </AccordionItemPanel>
                                    </AccordionItem>
                                    <AccordionItem>
                                        <AccordionItemHeading>
                                            <AccordionItemButton>
                                                05. What are they trying to?
                                            </AccordionItemButton>
                                        </AccordionItemHeading>
                                        <AccordionItemPanel>
                                            <p>
                                                Web designing in a powerful way of just not a profession, however for our Company. We have a tendency
                                                to believe the idea that smart looking to believe the idea that smart looking.
                                            </p>
                                        </AccordionItemPanel>
                                    </AccordionItem>
                                </Accordion>
                            </div>
                        </div>
                    </div>
                </section>

                <section class="ttm-row zero-padding-section overflow-hidden clearfix">
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-12 p-0">
                                <div id="google_map" class="google_map">
                                    <div class="map_container">
                                        <div id="map">
                                            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2483.5404230618797!2d-0.12174774859469174!3d51.5033006187238!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x487604b900d26973%3A0x4291f3172409ea92!2slastminute.com%20London%20Eye!5e0!3m2!1sen!2sin!4v1629115262628!5m2!1sen!2sin" height="590"></iframe>
                                        </div>
                                    </div>
                                    <div class="map-overlay">
                                        <div class="ttm-map-location">
                                            <h3>Find us</h3>
                                            <p>Schweizer Skischule lohnerhubels goergam Mtrasse 95 CH-3123 Belp</p>
                                            <ul class="map-list">
                                                <li>E-mail : <a href="mailto:contact@company.com" class="ttm-maplink">altech123@gmail.com</a></li>
                                                <li>Phone number : <a href="tel:+123456789" class="ttm-maplink">+1800 123 456789 99</a></li>
                                            </ul>
                                        </div>
                                        <div class="ttm-map-location mt-20">
                                            <h3>Business hours</h3>
                                            <ul class="map-list">
                                                <li>Mon-Fri : <span>8am to 9pm</span></li>
                                                <li>Sat : <span>9am to 3pm</span></li>
                                                <li>Sun : <span>closed</span></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

            </div>
            )
    }
}


export default Contact_01;